//deps
import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";

export const FreebieHeaderWrapper = styled.div(({ theme }) => ({
    display: "flex",
    padding: `${theme.spacing.xxxSmall} 0 ${theme.spacing.xxSmall} 0`,
    alignItems: "center",
}));

export const FreebieHeaderText = styled(Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.xxxSmall} 0 ${theme.spacing.xxxSmall}`,
}));

export const ReadTextBoxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    contain: content;
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    border: 1px solid ${({ theme }) => theme.colors[theme.colorMode].border_Secondary};
    position: relative;
    border-radius: ${({ theme }) => getCornerRadius(theme, "xSmall")};
    width: 64px;
    height: 28px;
`;

export const ReadOnlyBox = styled.div`
    border: 1px solid ${({ theme }) => theme.colors[theme.colorMode].border_Secondary};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    border-radius: ${({ theme }) => getCornerRadius(theme, "xSmall")};
`;
